import { render, staticRenderFns } from "./CRUDCustomer.vue?vue&type=template&id=7860162e&scoped=true"
import script from "./CRUDCustomer.vue?vue&type=script&lang=js"
export * from "./CRUDCustomer.vue?vue&type=script&lang=js"
import style0 from "./CRUDCustomer.vue?vue&type=style&index=0&id=7860162e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7860162e",
  null
  
)

export default component.exports